/* This file is autogenerated, see readme.md for instructions */
import MapSvgIcon from '@bloomreach/banana-theme/icons/map.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MapIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MapSvgIcon />
    </Icon>
  );
});

MapIcon.displayName = 'MapIcon';

export default MapIcon;
